import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ExtensionDeleteConnectionModalProps, ExtensionConnectionTypes } from 'src/Libs/installation-extensions/types'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { useExtensionConnection } from 'src/Libs/installation-extensions/hooks/extensions'

/**
 * A modal to delete the connection to Tibber.
 */
const TibberDeleteConnectionModal: React.FC<ExtensionDeleteConnectionModalProps> = ({
  loadInstallationExtensionStates,
  onClose: closeTibberDeleteConnectionModal,
  place = 0,
}) => {
  const { t } = useCustomTranslation()
  const { handleDeleteExtensionConnection } = useExtensionConnection(ExtensionConnectionTypes.Tibber)

  const handleOnClick = async (): Promise<void> => {
    try {
      await handleDeleteExtensionConnection()
      await loadInstallationExtensionStates()
      closeTibberDeleteConnectionModal()
    } catch (e) {
      closeTibberDeleteConnectionModal()
    }
  }

  const modalActions = {
    primary: {
      name: t('installation-extensions.tibber.details.connection-deletion-modal.actions.primary'),
      onClick: handleOnClick,
    },
    secondary: { name: t('installation-extensions.tibber.details.connection-deletion-modal.actions.secondary') },
  }

  return (
    <Dialog
      title={t('installation-extensions.tibber.details.connection-deletion-modal.titel')}
      onClose={closeTibberDeleteConnectionModal}
      actions={modalActions}
      maxWidth="sm"
    >
      <Typography variant="body2" mt={4}>
        {'installation-extensions.tibber.details.connection-deletion-modal.description'}
      </Typography>
    </Dialog>
  )
}

export default TibberDeleteConnectionModal
